var _circle, _circle2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHobbyDevelopmentActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon/challenge/hobby/active__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon/challenge/hobby/active__a)",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.172 30.385c-4.296 4.296-11.26 4.296-15.557 0-4.295-4.296-4.295-11.26 0-15.557 4.296-4.295 11.261-4.295 15.557 0 4.295 4.296 4.295 11.261 0 15.557ZM30.385 9.17c-4.296 4.296-11.26 4.296-15.557 0-4.295-4.295-4.295-11.26 0-15.556 4.296-4.295 11.261-4.295 15.557 0 4.296 4.296 4.296 11.261 0 15.557Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHobbyDevelopmentActive);
export default __webpack_public_path__ + "static/media/hobby-development-active.6697aed7668b19bb7476ccd409b21957.svg";
export { ForwardRef as ReactComponent };